import { atom } from 'recoil'

export const modalSchedulingState = atom({
  key: 'EmailSendingQueueManageModalScheduleSendingState',
  default: {
    show: false,
    idSending: undefined,
    idList: undefined,
    startDate: undefined,
    timeZoneCode: undefined,
    countImmediate: undefined,
    error: undefined,
    severity: undefined
  }
})
